import { render } from "./AboutView.vue?vue&type=template&id=4cf313a8"
const script = {}

import exportComponent from "/Users/hhz/Desktop/project/patriot_games/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__